import { FC } from 'react'
import { IonRouterLink } from '@ionic/react'

import { Chat } from '@/components/atoms/assets/Chat'

type ChatButtonProps = {
  userId: UUID
  page?: string
  onClick?: () => void
}

export const ChatButton: FC<ChatButtonProps> = ({ userId, page, onClick }) => (
  <IonRouterLink
    onClick={(e) => {
      e.stopPropagation()
      onClick?.()
    }}
    routerLink={userId ? `/messages/${userId}` : `/messages?page=${page}`}
  >
    <Chat />
  </IonRouterLink>
)
